import useOpen from '@/hooks/useOpen';
import AppContent from '@/components/AppContent';
import AppLoader from '@/components/AppLoader';
import { isStandalone } from '@/utils/platform/isStandalone';
import '@picsart/design-system/foundation.css';

import '@/utils/dev/logger';
// import './helpers/fetchInterceptor';
import useStyles from './styles';

export const App = () => {
  useStyles();

  const isOpen = useOpen();
  const isReady = isOpen || isStandalone();

  if (!isReady) {
    return <AppLoader />;
  }

  return <AppContent />;
};

export default App;
